<script lang="ts">
  import { fade } from 'svelte/transition';

  import type { TeoText } from '@/teoCore/text/TeoText';
  import { useCoreStore } from '@/ui/state/use-core-state.svelte';
  import { useActiveTeoText } from '@/ui/state/use-text-state.svelte';

  import Editor from './Editor.svelte';

  let { text }: { text: TeoText } = $props();
  let CS = useCoreStore();

  let T = useActiveTeoText();
  let TS = $derived($T.store);

  let mode = $derived($TS.view === 'text-generator' ? ('generator' as const) : ('editor' as const));
</script>

{#key text.id}
  {#if $CS.initialized && $TS.view !== 'new'}
    <div class="h-full max-h-full" transition:fade={{ duration: 200 }}>
      <Editor {text} {mode} />
    </div>
  {/if}
{/key}
